// Click / outbound-link analytics beacons for ThingSignal (POST track_clicks_path).
// Keep all of this here — do not add analytics logic to application.js (see .cursor/rules/no-custom-js-in-application.mdc).
// Wire from markup: data-controller="analytics-tracker", endpoint + payload values, actions calling #fire.
import { Controller } from "@hotwired/stimulus"
import { csrfToken } from "../utils/csrf_token"

export default class extends Controller {
  static values = {
    endpoint: String,
    payload:  Object
  }

  fire() {
    if (this.fired) return
    this.fired = true

    const body = new URLSearchParams({ ...this.payloadValue, authenticity_token: csrfToken() })

    if (navigator.sendBeacon) {
      navigator.sendBeacon(this.endpointValue, body)
    } else {
      fetch(this.endpointValue, { method: "POST", body, keepalive: true }).catch(() => {})
    }
  }
}
